import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { IconModule } from '../icon/icon.module';

import { PopoverContainer } from './popover-container.component';
import { Popover } from './popover.directive';
import { PopoverSection } from './popover-section.component';
import { PopoverActionList } from './popover-action-list.component';
import { PopoverActionItem } from './popover-action-item.component';
import { PopoverService } from './popover.service';

export { Popover } from './popover.directive';
export { PopoverContainer } from './popover-container.component';
export { PopoverSection } from './popover-section.component';
export { PopoverActionList } from './popover-action-list.component';
export { PopoverActionItem } from './popover-action-item.component';

@NgModule({
  declarations: [
    PopoverContainer,
    PopoverSection,
    PopoverActionList,
    PopoverActionItem,
    Popover,
  ],
  exports: [
    PopoverContainer,
    PopoverSection,
    PopoverActionList,
    PopoverActionItem,
    Popover,
  ],
  imports: [
    CommonModule,
    OverlayModule,
    IconModule,
  ],
  entryComponents: [
    PopoverContainer,
  ],
  providers: [
    PopoverService,
  ],
})
export class PopoverModule { }
